export default __webpack_public_path__ + "static/media/person_1@3x.47b80432.png";